// extracted by mini-css-extract-plugin
module.exports = {"paperClip":"PaperClip","isLeft":"isLeft","isCenter":"isCenter","isRight":"isRight"};